export default {
  loading: false,
  loadingExporting: false,
  accessUsers: [],
  accessUser: {
    enabled: true,
  },
  users: [],
  user: {
    enabled: true,
  },
  usersPagination: {},
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-users/store/states.js